// Shared labels / formatting for the Software Licence pages.
import { formatDateOnly } from "../../utils/dateOnly";

export const LICENSE_TYPES = [
  { value: "PER_USER", label: "Per User" },
  { value: "PER_DEVICE", label: "Per Device" },
  { value: "SUBSCRIPTION", label: "Subscription" },
  { value: "PERPETUAL", label: "Perpetual" },
  { value: "VOLUME", label: "Volume Licence" },
  { value: "OTHER", label: "Other" },
];

export const STATUS_OPTIONS = [
  { value: "ACTIVE", label: "Active" },
  { value: "EXPIRED", label: "Expired" },
  { value: "INACTIVE", label: "Inactive" },
  { value: "ARCHIVED", label: "Archived" },
];

export const VIEW_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "expiring_soon", label: "Expiring Soon" },
  { value: "expired", label: "Expired" },
  { value: "assigned", label: "Assigned" },
  { value: "available", label: "Seats Available" },
];

const STATUS_TONE = { ACTIVE: "green", EXPIRED: "red", INACTIVE: "gray", ARCHIVED: "purple" };

export const typeLabel = (v) => LICENSE_TYPES.find((t) => t.value === v)?.label || v || "-";

export function LicenseStatusBadge({ licence }) {
  const status = licence?.effective_status || licence?.status;
  const label = STATUS_OPTIONS.find((s) => s.value === status)?.label || status || "-";
  return (
    <span className="sl-badges">
      <span className={`ui-badge ui-badge-${STATUS_TONE[status] || "gray"}`}>{label}</span>
      {licence?.is_expiring_soon && <span className="ui-badge ui-badge-amber">Expiring Soon</span>}
    </span>
  );
}

export const money = (v) => {
  const n = Number(v ?? 0);
  return Number.isFinite(n)
    ? `₹${n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    : "-";
};

export const fmtDate = (v) => formatDateOnly(v, "-");

// /admin/..., /manager/..., /technician/... -> that role's licence base path.
export const licenceBasePath = (pathname) => {
  const role = String(pathname || "").split("/")[1] || "admin";
  return `/${role}/software-licences`;
};

export const apiError = (err, fallback) =>
  err?.response?.data?.message || err?.response?.data?.error || fallback;
